import RcTable from "rc-table";
import { TableProps as RcTableProps } from "rc-table/lib/Table";

import { createClassWithModifiers } from "utils";

export type TableVariant =
  | "bordered"
  | "stripped"
  | "stripped-even"
  | "black-header"
  | "dense"
  | "highlight-hover"
  | "elevated";

export interface TableProps<RecordType = unknown> extends RcTableProps<RecordType> {
  variants?: TableVariant[];
}

function Table<RecordType = unknown>({ className = "", variants = [], columns, ...props }: TableProps<RecordType>) {
  return (
    <RcTable
      prefixCls="table"
      className={`${className} ${createClassWithModifiers("table", variants, {
        "has-title": props.title,
        "has-footer": props.footer,
      })}`}
      columns={columns}
      {...props}
    />
  );
}

Table.Column = RcTable.Column;
Table.ColumnGroup = RcTable.ColumnGroup;
Table.Summary = RcTable.Summary;

export { Table };
